
        var result = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./baselayers-switcher.component.styl");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/lib/map/baselayers-switcher/baselayers-switcher.component.styl
// module id = 918
// module chunks = 0